import FqApi from '@/services/fq-api'

const baseUrl = '/pnetmessages'

export default {
  async getPnetQuoteStatusTypes() {
    const result = await FqApi.get(`${baseUrl}/quotestatustypes`)
    return result.data
  }
}